import { useState, useEffect, useRef, useMemo } from "react";
import { setBodyOverflow } from "../../marketplace-commons/helpers/bodyOverflow";
export function useCloseOnOuterClick(triggerRef, lockBody) {
    var _a = useState(false), expanded = _a[0], initialSetExpanded = _a[1];
    var wrapperRef = useRef(null);
    var setExpanded = useMemo(function () {
        return !lockBody
            ? initialSetExpanded
            : function (forceValue) {
                initialSetExpanded(function (value) {
                    var actualValue = forceValue !== undefined ? forceValue : !value;
                    setBodyOverflow(actualValue);
                    return actualValue;
                });
            };
    }, [lockBody]);
    useEffect(function () {
        var hasClickedOutside = function (event) {
            var containsTheNode = wrapperRef.current &&
                wrapperRef.current.contains(event.target);
            var isTheTrigger = triggerRef &&
                triggerRef.current &&
                triggerRef.current.isEqualNode(event.target);
            if (!containsTheNode && !isTheTrigger) {
                setExpanded(false);
            }
        };
        document.addEventListener("click", hasClickedOutside);
        return function () {
            document.removeEventListener("click", hasClickedOutside);
        };
    }, [triggerRef, wrapperRef, setExpanded]);
    return { wrapperRef: wrapperRef, expanded: expanded, setExpanded: setExpanded };
}
//# sourceMappingURL=useCloseOnOuterClick.js.map